import { Inventory2Outlined as BoxIcon } from '@mui/icons-material';

const EmptyScannerState = () => {
  return (
    <div className='flex flex-col items-center justify-center py-16 px-4 text-center bg-gray-50/50 rounded-lg border border-dashed border-gray-200'>
      <div className='w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm mb-4 border border-gray-100'>
        <BoxIcon className='text-gray-300' sx={{ fontSize: 32 }} />
      </div>
      <h3 className='text-gray-900 font-bold text-lg mb-1'>
        No hay pedidos escaneados
      </h3>
      <p className='text-gray-400 text-sm max-w-[280px] font-medium'>
        Seleccione un checkpoint y comience a escanear los pedidos.
      </p>
    </div>
  );
};

export default EmptyScannerState;
